export const darkTheme = {
    bg: "#07090f",
    bgLight: "#10141d",
    primary: "#3ee0c5",
    accent: "#f5b942",
    text_primary: "#f4f6fb",
    text_secondary: "#9aa3b5",
    card: "#121722",
    card_light: "#0c1018",
    button: "#3ee0c5",
    white: "#FFFFFF",
    black: "#000000",
}

export const lightTheme = {
    bg: "#f6f7fb",
    bgLight: "#ffffff",
    primary: "#0f766e",
    accent: "#b45309",
    text_primary: "#111318",
    text_secondary: "#4b5568",
    card: "#ffffff",
    card_light: "#eef1f6",
    button: "#0f766e",
    white: "#FFFFFF",
    black: "#000000",
}
